import { Directive, EventEmitter, HostBinding, HostListener, Output } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[appDragDrop]'
})
export class DragDropDirective {
  @Output()
  public fileDropped = new EventEmitter<any>();

  @HostBinding('style.visibility')
  visibility = 'hidden';

  @HostBinding('class.drag-over') 
  isDragOver = false;

  @HostListener('window:dragenter', ['$event'])
  onWindowDragEnter(event: DragEvent) {
    event.preventDefault();
    this.isDropZoneVisible(true);
  }

  @HostListener('window:drop', ['$event'])
  onWindowDrop(event: DragEvent) {
    event.preventDefault();
    this.isDropZoneVisible(false);
  }

  @HostListener('window:dragleave', ['$event'])
  onWindowDragLeave(event: DragEvent) {
    event.preventDefault();
    this.isDropZoneVisible(event.clientX !== 0 && event.clientY !== 0);
  }

  @HostListener('window:dragover', ['$event'])
  onWindowDragOver(event: DragEvent) {
    event.preventDefault();
    if (event.dataTransfer) {
      event.dataTransfer.effectAllowed = 'none';
      event.dataTransfer.dropEffect = 'none';
    }
  }

  @HostListener('dragover', ['$event'])
  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  @HostListener('dragleave', ['$event']) 
  onDragLeave(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.isDragOver = false;
  }

  @HostListener('drop', ['$event'])
  public onDrop(event: DragEvent) {
    this.isDragOver = false;
    const files = event.dataTransfer?.files;

    if (!files || files.length <= 0) {
      return;
    }
    this.fileDropped.emit(files);
  }

  private isDropZoneVisible(isVisible: boolean) {
    this.visibility = isVisible ? 'visible' : 'hidden';
  }
}
